import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { persistor } from '../index';

// Login Redux States
import { LOGIN_USER, LOGOUT_USER } from "./actionTypes";
import { loginError, loginSuccess, logoutUserSuccess } from "./actions";
import { reduxSerializedError } from "../../utils/utils";

import {
  logUser
} from "../../helpers/backend_helper";
import { setSession } from "../../utils/utils";
import { fetchUsersRequest } from "../actions";
import i18n from "../../locales/i18n";

function* login({ payload }) {
  const { user, navigate, isProfile } = payload;
  const userLogin = user;

  try {
    if (!isProfile)  {

      const response = yield call(logUser, {
        email: userLogin.email,
        password: userLogin.password,
      });
      
      const userLogged = response?.user;
      
      const { accessToken } = response;
      setSession(accessToken);
      
      yield put(loginSuccess(response));
      
      i18n.changeLanguage(userLogged.culture);
      localStorage.setItem("i18nextLng", userLogged.culture);
    } else {
      yield put(loginSuccess(userLogin));
    }
    
  } catch (error) {
    yield put(loginError(reduxSerializedError(error)));
  }
}

function* logoutUser({ payload: { history } }) {
  try {
    setSession(null);
    history('/login');
    yield call([persistor, persistor.purge]);
  } catch (error) {
    yield put(loginError(error));
  }
}

function* authSaga() {
  yield takeEvery(LOGIN_USER, login);
  yield takeEvery(LOGOUT_USER, logoutUser);
}

export default authSaga;
